/*@ngInject*/
const CreateAccountRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.createAccount = function (submissionId) {
        let url = '/rest/Account/createAccount?submissionId=' + submissionId,
            config = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

        return this.post(url, {}, config);
    };
};

angular.module('gw-um-submission')
    .service('createAccountRepository', CreateAccountRepository);
